// src/pages/KorisniLinkovi.js
import React from 'react';

// Definicija stilova inline, bez dodatnog CSS fajla
const styles = {
  main: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '2rem',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '1.5rem',
  },
  sectionTitle: {
    fontSize: '1.5rem',
    fontWeight: '600',
    marginBottom: '1rem',
  },
  list: {
    listStyleType: 'disc',
    paddingLeft: '1.5rem',
    marginBottom: '1.5rem',
  },
  listItem: {
    marginBottom: '0.5rem',
  },
  link: {
    color: '#1D4ED8',
    textDecoration: 'none',
  },
};

const linkovi = [
  {
    category: "Zakoni i propisi (Republika Srpska)",
    items: [
      { name: "Zakon o radu RS", url: "https://www.paragraf.ba/propisi/republika-srpska/zakon-o-radu.html" },
      { name: "Zakon o porezu na dohodak RS", url: "https://www.paragraf.ba/propisi/republika-srpska/zakon-o-porezu-na-dohodak.html" },
      { name: "Zakon o doprinosima RS", url: "https://www.paragraf.ba/propisi/republika-srpska/zakon-o-doprinosima.html" },
    ],
  },
  {
    category: "Zakoni i propisi (Federacija BiH)",
    items: [
      { name: "Zakon o radu FBiH", url: "https://www.pufbih.ba/v1/public/upload/zakoni/f0787-zakon-o-radu-precisceni-tekst.pdf" },
      { name: "Zakon o doprinosima FBiH", url: "https://advokat-prnjavorac.com/zakoni/Zakon_o_doprinosima_FBiH.pdf" },
    ],
  },
  {
    category: "Poreske uprave",
    items: [
      { name: "Porezna uprava Republike Srpske", url: "https://poreskaupravars.org/" },
      { name: "Porezna uprava Federacije BiH", url: "https://www.pufbih.ba/" },
      { name: "Uprava za indirektno oporezivanje BiH (PDV)", url: "https://www.uino.gov.ba/portal/en/" },
    ],
  },
  {
    category: "Online servisi Poreskih uprava",
    items: [
      { name: "Elektronske usluge Poreske uprave RS", url: "https://eusluge.poreskaupravars.org/" },
      { name: "E-usluge Porezne uprave FBiH", url: "https://www.pufbih.ba/v1/stranica/5" },
      { name: "e-Usluga u NPIS (Porezna uprava FBiH)", url: "https://www.pufbih.ba/v1/stranica/7" },
      { name: "Elektroničke usluge UINO BiH", url: "https://www.uino.gov.ba/portal/hr/e-usluge-hr/" },
      { name: "Pristup e-PDV", url: "https://e-porezi.uino.gov.ba:4443/" },
    ],
  },
  {
    category: "Ministarstva i institucije",
    items: [
      { name: "Ministarstvo finansija Republike Srpske", url: "https://www.vladars.net/sr-SP-Cyrl/Vlada/Ministarstva/mf/Pages/default.aspx" },
      { name: "Federalno ministarstvo finansija", url: "https://fbihvlada.gov.ba/" },
      { name: "Ministarstvo finansija i trezora BiH", url: "https://www.mft.gov.ba/" },
      { name: "Vijeće ministara BiH", url: "https://vijeceministara.gov.ba/" },
    ],
  },
  {
    category: "Sindikat i statistika",
    items: [
      { name: "Savez sindikata RS", url: "https://savezsindikatars.org/zakoni-i-kolektivni-ugovori/" },
      { name: "Zavod za statistiku Republike Srpske", url: "https://www.rzs.rs.ba/" },
      { name: "Federalni zavod za statistiku", url: "https://www.fzs.ba/" },
    ],
  },
];

export default function KorisniLinkovi() {
  return (
    <main style={styles.main}>
      <h1 style={styles.title}>Korisni linkovi</h1>
      {linkovi.map((cat) => (
        <section key={cat.category}>
          <h2 style={styles.sectionTitle}>{cat.category}</h2>
          <ul style={styles.list}>
            {cat.items.map((item) => (
              <li style={styles.listItem} key={item.url}>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.link}
                >
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </main>
  );
}
